import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import 'styles/index.scss'

import './i18n/config'

import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import { QueryClientProvider } from 'react-query'
import { Provider } from 'react-redux'

import store from 'redux/config'
import createQueryClient from 'queries'
import { launchDarklyConfig } from 'data/launchDarklyConfig'
import { PageLoadedProvider } from '@cms-max/cms-browser-api-client'
import { seoMetaData } from 'data/seo'

import * as serviceWorker from 'serviceWorker'
import { withLDProvider } from 'launchdarkly-react-client-sdk'

import { App } from 'App'
import { RedirectIfLangParamExistsAndIsDifferentFromSubdomain } from 'components/RedirectIfLangParamExistsAndIsDifferentFromSubdomain/RedirectIfLangParamExistsAndIsDifferentFromSubdomain'

if (process.env.NODE_ENV === 'development') {
  const axe = require('@axe-core/react')
  axe(React, ReactDOM, 1001, {})
}

const queryClient = createQueryClient()
const rootNode = document.getElementById('medicare-my-root')
const BASEPATH = process.env.REACT_APP_BASEPATH || ''
const AppWithLaunchDarklyProvider = withLDProvider(launchDarklyConfig)(App)

ReactDOM.render(
  <React.StrictMode>
    <RedirectIfLangParamExistsAndIsDifferentFromSubdomain>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <Router basename={BASEPATH}>
            <PageLoadedProvider seoMetadata={seoMetaData}>
                <AppWithLaunchDarklyProvider />
            </PageLoadedProvider>
          </Router>
        </QueryClientProvider>
      </Provider>
    </RedirectIfLangParamExistsAndIsDifferentFromSubdomain>
  </React.StrictMode>,
  rootNode
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
